import WalletConnectProvider from "@walletconnect/web3-provider";
import DcentProvider from "dcent-provider";
import { getCurrentNetwork } from "src/configs/connection-config";
import Web3Modal from "web3modal";

export default function web3ModalSetup() {
  return new Web3Modal({
    network: "mainnet",
    cacheProvider: true,
    theme: "light",
    providerOptions: {
      walletconnect: {
        package: WalletConnectProvider,
        options: {
          chainId: Number(getCurrentNetwork().chainId),
          rpc: {
            1: "https://eth-rpc.gateway.pokt.network",
            56: "https://bsc-dataseed1.binance.org/",
            97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
            250: "https://rpc.ftm.tools/",
            4010: "https://rpc.testnet.fantom.network/",
            11155111: "https://sepolia.infura.io/v3/8847d2d9d82947abadfa225cb777e922",
          },
          qrcodeModalOptions: {
            desktopLinks: [],
          },
        },
      },
      binancechainwallet: {
        package: true,
      },
      dcentwallet: {
        package: DcentProvider,
        options: {
          rpcUrl:
            Number(getCurrentNetwork().chainId) == 56
              ? "https://bsc-dataseed1.binance.org/"
              : "https://data-seed-prebsc-1-s1.binance.org:8545/",
        },
      },
    },
  });
}
